import { confirmDialog } from './confirm';

/**
 * THE GENTLE NOTE A SAMPLE BOARD ANSWERS A CHANGE WITH (mock 03).
 *
 * One place, because two callers raise it: the store's write guard
 * (`sampleBlocks`), which catches any change at the source so nothing is ever a
 * dead click, and a visibly-inert control (`useSampleBoard().note`), which
 * raises it on click before a write is even attempted. Both must say the same
 * thing, so the words live here, not in either caller.
 *
 * It is the app's own dialog (R24), never a bare alert, and it offers a way
 * forward rather than a wall. Resolves true when the person chose to start a
 * board of their own — the caller then opens the Start-a-board flow.
 */
export function sampleReadOnlyNote(name: string): Promise<boolean> {
  return confirmDialog({
    title: 'This is a sample — read only',
    body: `You're exploring ${name}. It's here to show how a board is set up, so changes aren't saved. Start a board of your own to begin your real work.`,
    confirmLabel: 'Start a board of your own',
    cancelLabel: 'Keep exploring',
    tone: 'caution',
  });
}

/**
 * THE CONFIRM BEFORE THE SAMPLE PAIR IS REMOVED (remove/restore mock 02).
 *
 * Shared by the two places that remove them — the "Remove these" on the picker's
 * Sample band and "Remove them" in Settings → Workspace — so both ask the exact
 * same question. CAUTIONARY, never destructive: removing archives the pair (it
 * never deletes), and they can be brought back from Settings, so the dialog is
 * the petrol primary, not the solid-red one reserved for permanent loss (R24).
 * Resolves true when the person chose to remove.
 */
export function confirmRemoveSamples(): Promise<boolean> {
  return confirmDialog({
    title: 'Remove the sample boards?',
    body: (
      <>
        This takes the two <b>Example Co.</b> samples — a finished delivery project and a service
        board — out of the board list for everyone in this workspace. They're sample boards, so nothing
        real is lost, and you can bring them back any time from <b>Settings → Workspace</b>.
      </>
    ),
    confirmLabel: 'Remove samples',
    cancelLabel: 'Keep them',
    tone: 'caution',
  });
}
